<template>
  <div>
    <van-nav-bar
      title="定期宝"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('app.common.pull_to_reload')":loosing-text="$t('app.common.release_to_reload')":loading-text="$t('app.common.loading')">
      <van-row>
        <van-col span="8">
          <div class="capital">
            <h5>当前余额</h5>
            <p>{{ account.movableamount }}美元</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>已投资额</h5>
            <p>{{ useamount.toFixed(2) }}美元</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>当前资产</h5>
            <p>{{ account.amount }}美元</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>当月收益</h5>
            <p>{{ account.interestthis }}美元</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>上月收益</h5>
            <p>{{ account.interestlast }}美元</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>历史收益</h5>
            <p>{{ account.interestamount }}美元</p>
          </div>
        </van-col>
      </van-row>
      <div class="capital-btn">
        <van-row>
          <van-col span="12">
            <van-button round type="danger" size="small" @click="movein.status = true">转入</van-button>
          </van-col>
          <van-col span="12">
            <van-button round type="info" size="small" @click="moveout.status = true">转出</van-button>
          </van-col>
        </van-row>
      </div>
      <van-divider/>
      <van-cell-group title="新建定期宝">
        <van-field v-model="regular.money" label="金额" placeholder="请输入投资额度" type="digit"/>
      </van-cell-group>
      <div class="multiple_box">
        <div class="multiple" v-for="(item,index) in financetype" :key="index" :class="{active_multiple:cut===index}"
             @click="setCut(index,item)">
          <a href="javascript:void(0);">
            <p>{{ item.name }}</p>
            <p>{{ item.period }}{{ (Number(item.interest)*100).toFixed(2) }}%</p>
            <p class="van-ellipsis">收益{{ (Number(regular.money)*Number(item.interest)).toFixed(2) }}美元</p>
          </a>
        </div>
        <div style="clear:both;"></div>
      </div>
      <div class="fincance-btn">
        <van-button round type="danger" size="small" block @click="createFinance">确定</van-button>
      </div>
      <div class="hint">
        <h5>温馨提示</h5>
        <p>可时时结算并转出提现，若未到期提前结算将不会有任何利息到账</p>
      </div>
      <van-tabs>
        <van-tab title="当前投资">
          <div class="detailed_box" v-for="(item,index) in currentData" :key="index" @click="closefund(item)">
            <div class="detailed">
              <h5>编号</h5>
              <p>{{ item.order }}</p>
            </div>
            <div class="detailed">
              <h5>投资金额</h5>
              <p>{{ item.amount }}</p>
            </div>
            <div class="detailed">
              <h5>投资周期</h5>
              <p>{{ item.period }}</p>
            </div>
            <div class="detailed">
              <h5>开始时间</h5>
              <p>{{ item.starttime }}</p>
            </div>
            <div class="detailed">
              <h5>结束时间</h5>
              <p>{{ item.endtime }}</p>
            </div>
            <div class="detailed">
              <h5>预计收益</h5>
              <p>{{ item.estimateinterest }}</p>
            </div>
            <div style="clear:both;"></div>
          </div>
        </van-tab>
        <van-tab title="历史投资">
          <div class="detailed_box" v-for="(item,index) in historyData" :key="index">
            <div class="detailed">
              <h5>编号</h5>
              <p>{{ item.order }}</p>
            </div>
            <div class="detailed">
              <h5>投资金额</h5>
              <p>{{ item.amount }}</p>
            </div>
            <div class="detailed">
              <h5>投资周期</h5>
              <p>{{ item.period }}</p>
            </div>
            <div class="detailed">
              <h5>开始时间</h5>
              <p>{{ item.starttime }}</p>
            </div>
            <div class="detailed">
              <h5>结束时间</h5>
              <p>{{ item.endtime }}</p>
            </div>
            <div class="detailed">
              <h5>实际收益</h5>
              <p>{{ item.realinterest }}</p>
            </div>
            <div style="clear:both;"></div>
          </div>
        </van-tab>
        <van-tab title="资金明细">
          <van-cell-group>
            <van-cell title="开始日期" :value="capitalDetails.startDate" @click="capitalDetails.startStatus = true" placeholder="点击选择开始日期" />
            <van-popup v-model="capitalDetails.startStatus" position="bottom">
              <van-datetime-picker
                v-model="capitalDetails.date"
                @confirm="onConfirmStartDate"
                @cancel="capitalDetails.startStatus = false"
                type="date"
                title="选择年月日"
              />
            </van-popup>

<!--            <van-calendar v-model="capitalDetails.status" type="range" :show-confirm="false" @confirm="onConfirmDate" />-->
          </van-cell-group>
          <van-cell-group>
            <van-cell title="结束日期" :value="capitalDetails.endDate" @click="capitalDetails.endStatus = true" placeholder="点击选择结束日期" />
            <van-popup v-model="capitalDetails.endStatus" position="bottom">
              <van-datetime-picker
                v-model="capitalDetails.date"
                @confirm="onConfirmEndDate"
                @cancel="capitalDetails.endStatus = false"
                type="date"
                title="选择年月日"
              />
            </van-popup>

            <!--            <van-calendar v-model="capitalDetails.status" type="range" :show-confirm="false" @confirm="onConfirmDate" />-->
          </van-cell-group>
          <van-button type="primary" block size="small" @click="getCapitalDetails(true)">查询</van-button>
          <van-list
            v-model="capitalDetails.loading"
            :finished="capitalDetails.finished"
            finished-text="没有更多了"
            @load="getCapitalDetails(false)"
          >
            <van-cell-group>
              <van-cell v-for="(item,index) in capitalDetails.data" :key="index">
                <template #title>
                  {{ item.name }}
                </template>
                <template #label>
                  余额:{{ item.balance }}
                </template>
                <template #default>
                  <span>{{ item.amount }}美元</span>
                  <br>{{ item.time }}美元
                </template>
              </van-cell>
            </van-cell-group>
<!--            <van-cell v-for="item in list" :key="item" :title="item" />-->
          </van-list>
        </van-tab>
      </van-tabs>

    </van-pull-refresh>
    <van-dialog v-model="movein.status" title="转入" show-cancel-button  :beforeClose="moveinBtn">
      <van-cell-group>
        <van-field type="digit" v-model="movein.money" label="转入金额" placeholder="请输入转入金额" />
      </van-cell-group>
    </van-dialog>
    <van-dialog v-model="moveout.status" title="转出" show-cancel-button  :beforeClose="moveoutBtn">
      <van-cell-group>
        <van-field type="digit" v-model="moveout.money" label="转出金额" placeholder="请输入转出金额" />
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
  export default {
    name: "FinanceFund",
    data() {
      return {
        regular: {
          money: 0,
        },
        movein:{
          money:0,
          status:false
        },
        moveout:{
          money:0,
          status:false
        },
        account: {
          amount: '0.00',
          movableamount: '0.00',
          totalamount: '0.00',
          interestamount: '0.00',
          interestthis: '0.00',
          interestlast: '0.00',
        },
        financetype: [],
        cut: 0,
        currentData: [],
        tid: 0,
        historyData: [],
        capitalDetails: {
          date: new Date(),
          startStatus:false,
          startDate:this.$moment().format("YYYY-MM-DD"),
          endStatus:false,
          endDate:this.$moment().format("YYYY-MM-DD"),
          data: [],
          page: 1,
          num: 20,
          loading:false,
          finished:false
        },
        isLoading: false,

      }
    },
    computed: {
      useamount: function () {
        let that = this;
        return Number(that.account.amount) - Number(that.account.movableamount);
      },
      earnings: function () {
        let that = this;
      }
    },
    methods: {
      isLogin(){
        let that = this;
        if (!that.$store.state.loginType){
          that.$router.push('/login')
        }
      },
      getFinanceFund() {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "finance_fund",
              token: sessionStorage.getItem("token"),
              action: 'queryfund'
            }
          })
          .then(function (res) {
            if (res.data.code == 1) {
              let resData = res.data;
              that.account = resData.data.account;
              that.financetype = resData.data.financetype;
              that.currentData = resData.data.details;
              that.tid = that.financetype[that.cut].tid
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(that.$t(res.data.msg));

            }
          });
      },
      setCut(index, data) {
        this.cut = index;
        this.tid = data.tid;
      },
      createFinance() {
        let that = this;
        let money = parseInt(that.regular.money);
        if (money < 0 || isNaN(money)) {
          that.$toast.fail(this.$t('app.financefund.incorect_amount'));
        } else {
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "finance_fund",
                token: sessionStorage.getItem("token"),
                action: 'createaccount',
                amount: that.regular.money,
                financetypeid: that.tid
              }
            })
            .then(function (res) {
              if (res.data.code == 1) {
                let resData = res.data;
                that.$toast({
                  type: 'success',
                  message: resData.msg,
                  onClose: function () {
                    that.getFinanceFund();
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(that.$t(res.data.msg));

              }
            });
        }

      },
      closefund(data) {
        let that = this;
        that.$dialog.confirm({
          title: '定期宝结算',
          message: '您的定期宝还没到期,提前结算您将损失所有的利息',
        })
          .then(() => {
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "finance_fund",
                  token: sessionStorage.getItem("token"),
                  action: 'closefund',
                  financedetailid: data.id
                }
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  let resData = res.data;
                  that.$toast({
                    type: 'success',
                    message: resData.msg,
                    onClose: function () {
                      that.mainMethod();
                    }
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$toast.fail(that.$t(res.data.msg));

                }
              });
          })
          .catch(() => {
            // on cancel
          });

        /*this.$confirm('您的定期宝还没到期,提前结算您将损失所有的利息', '定期宝结算', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "finance_fund",
                token: sessionStorage.getItem("token"),
                action: 'closefund',
                financedetailid: data.id
              }
            })
            .then(function (res) {
              if (res.data.code == 1) {
                let resData = res.data;
                that.$toast({
                  type: 'success',
                  message: resData.msg,
                  onClose: function () {
                    that.mainMethod();
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(that.$t(res.data.msg));

              }
            });
        }).catch(() => {

        });*/
      },
      getquerydetails() {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "finance_fund",
              token: sessionStorage.getItem("token"),
              action: 'querydetails',
              status: '2'
            }
          })
          .then(function (res) {
            if (res.data.code == 1) {
              let resData = res.data;
              that.historyData = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(that.$t(res.data.msg));

            }
          });
      },
      getCapitalDetails(status) {
        let that = this;
        if (status){
          that.capitalDetails.page = 1;
          that.capitalDetails.finished = false;
        }
        that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "finance_fund",
              token: sessionStorage.getItem("token"),
              action: 'querylog',
              page: that.capitalDetails.page,
              num: that.capitalDetails.num,
              start: that.capitalDetails.startDate,
              end: that.capitalDetails.endDate
            }
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.capitalDetails.loading = false;
              let resData = res.data;
              let number = resData.data.length;
              if (number < 20){
                that.capitalDetails.finished = true;
              }
              status ? that.capitalDetails.data = that.capitalDetails.data = resData.data : that.capitalDetails.data = that.capitalDetails.data.concat(resData.data);
              let page = that.capitalDetails.page;
              that.capitalDetails.page = page + 1;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(that.$t(res.data.msg));

            }
          })
          .catch(()=>{
              that.capitalDetails.loading = false; 
              that.capitalDetails.finished = true;
          });
      },
      moveoutBtn(action,done) {
        let that = this;
        switch (action) {
          case 'confirm':
            let money = parseInt(that.moveout.money);
            if (money <= 0 || isNaN(money)) {
              this.$toast({
                type: 'warning',
                message: '请输入正确金额'
              });
              done(false);
            } else {
              that.$http({
                  url: "/",
                  method: "post",
                  data: {
                    nozzle: "finance_fund",
                    token: sessionStorage.getItem("token"),
                    action: 'moveout',
                    amount: money,
                  }
                })
                .then(function (res) {
                  if (res.data.code == 1) {
                    that.$toast({
                      message: res.data.msg,
                      type: 'success',
                      onClose: function () {
                        that.mainMethod();
                        that.moveout.money = 0;
                        done()
                      }
                    });
                  } else if (res.data.code == 0 || res.data.code == -1) {
                    that.$toast.fail(that.$t(res.data.msg));

                    done(false)
                  }
                });
            }
            break;
          case 'cancel':
            done();
            break;

        }
      },
      moveinBtn(action,done) {
        let that = this;
        switch (action) {
          case 'confirm':
            let money = parseInt(that.movein.money);
            if (money <= 0 || isNaN(money)) {
              this.$toast({
                type: 'warning',
                message: '请输入正确金额'
              });
              done(false);
            }else{
              that.$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "finance_fund",
                  token: sessionStorage.getItem("token"),
                  action: 'movein',
                  amount: money,
                }
              })
                .then(function (res) {
                  if (res.data.code == 1) {
                    that.$toast({
                      message: res.data.msg,
                      type: 'success',
                      onClose: function () {
                        that.mainMethod();
                        that.movein.money = 0;
                        done()
                      }
                    });
                  } else if (res.data.code == 0 || res.data.code == -1) {
                    that.$toast.fail(that.$t(res.data.msg));

                    done(false);
                  }
                });
            }

            break;
          case 'cancel':
            done();
            break;
        }
      },
      mainMethod() {
        this.getFinanceFund();
        this.getquerydetails();
        this.getCapitalDetails(true);
      },
      onRefresh() {
        this.mainMethod();
        this.isLoading = false;
      },
      onConfirmDate(date){
        const [start, end] = date;
        this.capitalDetails.status = false;
        this.capitalDetails.showDate = `${this.formatDate(start)} - ${this.formatDate(end)}`;
        this.capitalDetails.date = [this.timeFormat(date[0]),this.timeFormat(date[1])];
      },
      timeFormat(time) {
        let year = time.getFullYear();
        let month = time.getMonth() + 1;
        let day = time.getDate();
        return year + '-' + month + '-' + day
      },
      formatDate(date) {
        return `${date.getMonth() + 1}/${date.getDate()}`;
      },
      onConfirmStartDate(time){
        this.capitalDetails.startDate = this.$moment(time).format("YYYY-MM-DD");
        this.capitalDetails.startStatus = false;
      },
      onConfirmEndDate(time){
        this.capitalDetails.endDate = this.$moment(time).format("YYYY-MM-DD");
        this.capitalDetails.endStatus = false;
      }
    },
    mounted: function () {
      this.isLogin();
      this.getFinanceFund();
      this.getquerydetails();
      this.getCapitalDetails(true);
    },
  }
</script>

<style scoped>
  .capital {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .capital h5 {
    margin: 0;
    color: #999;
    font-size: 14px;
    font-weight: 300;
  }

  .capital p {
    margin: 0;
    color: red;
    font-size: 14px;
    font-weight: bold;
  }

  .capital-btn {
    margin-top: 10px;
    text-align: center;
  }

  .multiple_box {
    width: 90%;
    margin: 0 auto;
  }

  .multiple {
    width: 31%;
    float: left;
    margin-right: 1.25%;
    background: white;
    border: 1px solid #666;
    border-radius: 4px;
    padding: 10px 0;
    text-align: center;
  }

  .multiple p {
    line-height: 1.5;
    font-weight: bold;
    font-size: 14px;
    color: #909399;
    margin: 0;
  }

  .active_multiple {
    background: #f56c6c;
    color: #fff !important;
    border: 1px solid #f56c6c !important;
  }

  .active_multiple p {
    color: #fff;
  }

  .multiple:last-child {
    margin-right: 0;
  }

  .fincance-btn {
    margin-top: 10px;
  }

  .hint {
    width: 90%;
    margin: 10px auto;
  }

  .hint h5 {
    margin: 0;
    font-size: 14px;
    color: #333;
  }

  .hint p {
    margin: 0;
    font-size: 14px;
    color: #333;
  }
  .detailed_box{
    width: 95%;
    margin: 0 auto;
    border-bottom: 1px solid #999;
    padding-bottom: 10px;
  }
  .detailed{
    margin-top: 10px;
    float: left;
    width: 33.33%;
  }

  .detailed h5 {
    text-align: center;
    margin: 0;
    color: #333;
    font-size: 14px;
  }

  .detailed p {
    text-align: center;
    margin: 0;
    color: #999;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FinanceFund.vue